<template>
  <v-container>
    <v-col>
      <h3>Контент страницы "Контакты"</h3>

      <!--      <v-card>-->
      <v-card-text>
        <v-form ref="hpsContactForm">
          <yandex-map
            v-show="coords && coords.length > 0"
            style="height: 300px"
            :coords="coords"
            zoom="17"
          >
            <ymap-marker marker-type="placemark" marker-id="1" :coords="coords"></ymap-marker>
          </yandex-map>

          <v-col lg12>
            <v-text-field v-model="coords" label="Координаты" name="coordinates"></v-text-field>
            <input type="text" name="latitude" v-model="contact.latitude" style="display: none" />
            <input type="text" name="longitude" v-model="contact.longitude" style="display: none" />
          </v-col>
          <v-col cols="12">
            <v-text-field
              hint="email"
              label="email"
              v-model="contact.email"
              type="email"
              name="email"
            >
            </v-text-field>
            <v-text-field
              hint="Номер телефона"
              label="Номер телефона"
              v-model="contact.phone_number"
              mask="###.###.###-##"
              name="phone_number"
            >
            </v-text-field>
            <v-textarea label="Адрес" v-model="contact.address" name="address"> </v-textarea>
          </v-col>
          <v-btn color="success" @click="save" :loading="loading">Соранить</v-btn>
        </v-form>
      </v-card-text>
      <!--      </v-card>-->
    </v-col>
  </v-container>
</template>

<script>
import ckeditorMixin from '@/mixins/ckeditor'

export default {
  name: 'CreateEditHPSContacts',
  mixins: [ckeditorMixin],
  data() {
    return {
      loading: false,
      contact: {
        longitude: '',
        latitude: '',
      },
    }
  },
  computed: {
    coords: {
      get() {
        return this.contact ? [this.contact.latitude, this.contact.longitude] : []
      },
      set(el) {
        this.contact.latitude = el.split(',')[0]
        this.contact.longitude = el.split(',')[1]
      },
    },
  },
  mounted() {
    this.axios({
      url: '/v1/hps/contacts',
      method: 'get',
    })
      .then((res) => {
        this.contact = res.data
      })
      .catch((err) => {
        this.showSnackbar(err.response ? err.response.data : err, 'error')
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    save() {
      const fd = new FormData(this.$refs.hpsContactForm.$el)
      this.loading = true
      this.axios({
        url: '/v1/hps/contacts',
        method: 'post',
        data: fd,
      })
        .then((res) => {
          this.contact = res.data
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
